<template>
  <div class="template-two-column">
    <div
      class="template-two-column__container"
      :style="singleArticleContainerStyle"
    >
      <!-- Контент должен находиться выше других элементов. Важно для seo. (LH-1368)-->
      <div class="single-article__wrapper">
        <div class="single-article">
          <section class="single-article__content">
            <AdminControlsPanel
              v-if="isAuthenticatedInWordpress"
              class="admin-controls"
              :views-count="viewsCount"
              :edit-link-href="editLinkHref"
              :loading="getLoadingViews(article.id)"
              @click-on-restore-button="updateViewsCount(article.id)"
            />
            <ArticleCard
              class="single-article-card"
              :article="article"
              :title="articleTitle"
              :comments-count="commentsCount"
              :user="user"
              :favorite="favorites"
              :folders="folders"
              :to-comments-link="false"
              :comments-enabled="article.commentsEnabled"
              @favorite-delete="(favorite) => onFavoriteDelete(favorite, article)"
              @favorite-create-folder-and-add="
                (nameFolder) => onFavoriteCreateFolderAndAdd(nameFolder, article)
              "
              @favorite-create-folder-and-transfer="
                (nameFolder, favorite) =>
                  onFavoriteCreateFolderAndTransfer(nameFolder, favorite, article)
              "
              @favorite-transfer-to-folder="
                (favorite, folder) => onFavoriteTransferToFolder(favorite, folder, article)
              "
              @favorite-add-to-folder="(folder) => onFavoriteAddToFolder(folder, article)"
              @favorite-deferred="onFavoriteDeferred"
              @clicked-on-category="onClickOnCategory"
            />

            <!-- id article указан в JSON+LD -->
            <article
              id="article"
              class="single-article__post-content single-article__content-container"
              @click="checkImageClick"
            >
              <template v-for="(content, idx) in slicedContents">
                <!-- контент статьи-->
                <TheContent
                  v-for="item of content"
                  :key="item.id"
                  :elem="item"
                  :lazy-loading-enabled="true"
                />

                <!-- виджеты внутри контента-->
                <WidgetsRendererContainer
                  v-if="
                    isWidgetsRendererVisible && typeof widgetsInsideContent[idx] !== 'undefined'
                  "
                  :widgets="widgetsInsideContent[idx]"
                />
              </template>
            </article>

            <div class="article__note-container">
              <!-- текст под контентом статьи. Обложка, источник и тп-->
              <ArticleNote
                class="article-note"
                :class="{ 'article-note_empty': !articleNotes.length }"
                :notes="articleNotes"
              />
            </div>
            <div class="article__actions-container">
              <component
                :is="articleCardComponent"
                class="article__actions"
                event-position="bottom"
                in-page-position="bottom"
                :article-id="article.id"
                :url="article.teaserUrl || article.url"
                :cover-url="
                  article.img && article.img[0] && article.img[0].url ? article.img[0].url : null
                "
                :comments-enabled="article.commentsEnabled && !article.teaserUrl"
                :comments-count="commentsCount"
                :title="articleTitle"
                :user="user"
                :favorite="favorites"
                :folders="folders"
                :can-have-reactions="article.canHaveReactions"
                @favorite-delete="(favorite) => onFavoriteDelete(favorite, article)"
                @favorite-create-folder-and-add="
                  (nameFolder) => onFavoriteCreateFolderAndAdd(nameFolder, article)
                "
                @favorite-create-folder-and-transfer="
                  (nameFolder, favorite) =>
                    onFavoriteCreateFolderAndTransfer(nameFolder, favorite, article)
                "
                @favorite-transfer-to-folder="
                  (favorite, folder) => onFavoriteTransferToFolder(favorite, folder, article)
                "
                @favorite-add-to-folder="(folder) => onFavoriteAddToFolder(folder, article)"
                @favorite-deferred="onFavoriteDeferred"
              />
            </div>
          </section>

          <!-- зона виджетов "над комментариями"-->
          <WidgetsRendererContainer
            v-if="isWidgetsRendererVisible || isAdsException"
            class="widgets above-comments-widgets__container"
            :widgets="aboveCommentsWidgets"
          />

          <!-- комментарии-->
          <CommentsContainer
            v-if="showComments"
            :id="article.id"
            class="comments"
          />

          <!-- зона виджетов "под комментариями"-->
          <WidgetsRendererContainer
            v-if="isWidgetsRendererVisible || isAdsException"
            class="below-comments-widgets__container"
            :widgets="belowCommentsWidgets"
          />
        </div>
      </div>

      <!-- Полноэкранная галерея-->
      <FullScreenGallery
        v-if="isGalleryVisible"
        :image-urls="imagesSrc"
        :srcset="imagesSrcset"
        :current-slide="currentImageId"
        @close="closeGallery"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import GeneralTemplates from './general'; // Берем за основу компонент generalTemplate, но даем ему уникальное имя

  // Берем за основу компонент generalTemplate, но даем ему уникальное имя
  // Без уникального имени может рендериться не корректный шаблон
  export default defineNuxtComponent({
    ...GeneralTemplates,
    name: 'TwoColumn',
  });
</script>

<style lang="scss" scoped>
  $borderColor: #e7e7e7;

  $border: 1px solid #e7e7e7;

  .template-two-column {
    &__container {
      height: 100%;
    }

    .single-article__post-content {
      max-width: 640px;
      width: 100%;
      margin: 0 auto;

      @include tablet {
        margin: 0;
        max-width: none;
      }
    }

    .single-article {
      width: 100%;
      margin: 0 auto;
      max-width: 640px;

      @include desktop {
        max-width: unset;
      }

      &__content {
        max-width: 640px;
        background: white;
        margin: 0px auto 24px;
        width: 100%;

        @include tablet {
          border: none;
          padding: 0 24px;
        }

        @include big-tablet {
          border: 1px solid #e7e7e7;
          padding: 0;
        }

        @include desktop {
          max-width: 780px;
        }
      }

      &__content-container {
        @include tablet {
          padding: 0;
        }

        @include big-tablet {
          padding: 0 24px;
        }
      }
    }

    .comments {
      margin-bottom: 16px;

      @include tablet {
        margin-bottom: 0;
      }
    }

    .admin-controls {
      margin-left: 16px;
      padding-top: 16px;

      @include tablet {
        margin-left: 24px;
      }
    }

    .admin-controls + .single-article-card {
      padding-top: 12px;

      @include tablet {
        padding-top: 0px;
      }
    }

    .single-article__page-content-wrapper {
      background: white;
      padding: 16px 16px 32px;
      max-width: 642px;
      margin: 0 auto;

      @include tablet {
        padding: 24px 24px 40px;
        border: 1px solid #e7e7e7;
        margin-top: 8px;
      }

      @include big-tablet {
        max-width: 782px;
        margin-top: 0;
        height: 100%;
      }
    }

    .single-article__page-content {
      max-width: 642px;
      margin: 0 auto;
      padding: 0;
    }
  }
</style>
